<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import { isPhoneE164OrEmpty, isNumber } from 'shared/helpers/Validators';

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiKey: '',
      phoneNumberId: '',
      businessAccountId: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    apiKey: { required },
    phoneNumberId: { required, isNumber },
    businessAccountId: { required, isNumber },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'whatsapp',
              phone_number: this.phoneNumber,
              provider: 'whatsapp_cloud',
              provider_config: {
                api_key: this.apiKey,
                phone_number_id: this.phoneNumberId,
                business_account_id: this.businessAccountId,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        , {type: 'error'});
      }
    },
  },
};
</script>

<template>
  <form class="flex w-full flex-col" @submit.prevent="createChannel()">
    <!-- Layout 2 cột -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- Cột trái: Thông tin cơ bản -->
      <div class="space-y-4">
        <!-- Inbox Name -->
        <div>
          <label :class="{ error: v$.inboxName.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
            <input
              v-model="inboxName"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
              @blur="v$.inboxName.$touch"
            />
            <span v-if="v$.inboxName.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
            </span>
          </label>
        </div>

        <!-- Phone Number -->
        <div>
          <label :class="{ error: v$.phoneNumber.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
            <input
              v-model="phoneNumber"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
              @blur="v$.phoneNumber.$touch"
            />
            <span v-if="v$.phoneNumber.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
            </span>
          </label>
        </div>

        <!-- API Key -->
        <div>
          <label :class="{ error: v$.apiKey.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.LABEL') }}
            <input
              v-model="apiKey"
              type="text"
              :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.PLACEHOLDER')"
              @blur="v$.apiKey.$touch"
            />
            <span v-if="v$.apiKey.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.ERROR') }}
            </span>
          </label>
        </div>
      </div>

      <!-- Cột phải: Thông tin kỹ thuật -->
      <div class="space-y-4">
        <!-- Phone Number ID -->
        <div>
          <label :class="{ error: v$.phoneNumberId.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
            <input
              v-model="phoneNumberId"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER')
              "
              @blur="v$.phoneNumberId.$touch"
            />
            <span v-if="v$.phoneNumberId.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
            </span>
          </label>
        </div>

        <!-- Business Account ID -->
        <div>
          <label :class="{ error: v$.businessAccountId.$error }">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.LABEL') }}
            <input
              v-model="businessAccountId"
              type="text"
              :placeholder="
                $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.PLACEHOLDER')
              "
              @blur="v$.businessAccountId.$touch"
            />
            <span v-if="v$.businessAccountId.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.ERROR') }}
            </span>
          </label>
        </div>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="w-full flex justify-center mt-6">
      <woot-submit-button
        class="!bg-n-bluegray-4 !text-white rounded-lg"
        :loading="uiFlags.isCreating"
        :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}
</style>